export default "assets/images/logo-ea30dafb.svg";